/* Opiniones de clientes.

   O resumo (nota, quantidade, barras) já vem no HTML. Este arquivo só monta a
   lista, a faixa de fotos e o visor. Busca UM json — o do próprio produto.

   Avatar: sprite único de 96px por célula, 19 por linha. A posição de cada
   pessoa é o índice `a`. Sem 358 requisições, sem 358 arquivos no tema.      */
(function () {
  var COLS = 19, CELULA = 96, TAM = 32, PAGINA = 8;

  /* Estrela PARCIAL, a mesma mecanica do snippet ca-estrellas.liquid: duas
     camadas de cinco, a dourada cortada em nota/5. O desenho anterior usava
     Math.round(nota) e transformava 4,5 em cinco estrelas cheias e 4,4 em
     quatro -- meia estrela de diferenca virava uma estrela inteira na tela. */
  function estrellas(nota, classe) {
    var n = Number(nota);
    if (!isFinite(n)) n = 0;
    n = Math.max(0, Math.min(5, n));
    var pct = Math.round(n / 5 * 1000) / 10;
    return '<span class="' + classe + ' ca-est" style="--ca-est:' + pct + '%"' +
           ' role="img" aria-label="' + n.toString().replace('.', ',') + ' de 5 estrellas">' +
           '<span class="ca-est__bg" aria-hidden="true">★★★★★</span>' +
           '<span class="ca-est__fg" aria-hidden="true">★★★★★</span></span>';
  }

  /* A Amazon separa título e corpo. Aqui o título é a última frase — é a que
     carrega o veredito ("Lo recomiendo", "Buena relación entre precio y utilidad"). */
  function partir(texto) {
    /* sem lookbehind de propósito: `(?<=\.)` derruba o arquivo inteiro em
       Safari antigo, e um erro de sintaxe aqui apagaria a lista toda. */
    var t = texto.trim();
    var m = t.match(/[^.]+\.\s*$/);
    if (!m) return { tit: '', corpo: t };
    var corpo = t.slice(0, m.index).trim();
    if (!corpo) return { tit: '', corpo: t };
    return { tit: m[0].trim().replace(/\.$/, ''), corpo: corpo };
  }

  function escapar(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function posicaoAvatar(idx) {
    var col = idx % COLS, lin = Math.floor(idx / COLS), esc = TAM / CELULA;
    return 'background-size:' + (COLS * TAM) + 'px auto;background-position:' +
           (-col * TAM) + 'px ' + (-lin * TAM) + 'px;';
  }

  function iniciar(sec) {
    var lista = sec.querySelector('[data-ca-op-lista]');
    var botao = sec.querySelector('[data-ca-op-mas]');
    var caixaFotos = sec.querySelector('[data-ca-op-fotos]');
    var tira = caixaFotos && caixaFotos.querySelector('.ca-op__tira');
    var visor = document.querySelector('[data-ca-op-visor]');
    /* a base dos assets sai do próprio sprite: `asset_url` gruda um ?v=... no
       fim, e montar a base por concatenação punha a query no meio da URL. */
    var sprite = sec.dataset.sprite;
    var base = sprite.replace(/ca-avatars\.jpg.*$/, '');
    var dados = [], mostrados = 0;

    function abrirFoto(src, pie) {
      if (!visor) return;
      visor.querySelector('[data-ca-op-visor-img]').src = src;
      visor.querySelector('[data-ca-op-visor-pie]').textContent = pie;
      if (visor.showModal) visor.showModal();
    }

    function cartao(r) {
      var p = partir(r.t);
      var avatar = Number(r.a) > 0
        ? '<span class="ca-op__av" style="background-image:url(' + sprite + ');' + posicaoAvatar(r.a) + '"></span>'
        : '<span class="ca-op__av ca-op__av--neutro" aria-hidden="true">' + escapar((r.n || '').trim().charAt(0).toUpperCase()) + '</span>';
      var foto = r.p
        ? '<button type="button" class="ca-op__foto" data-foto="' + escapar(base + r.p) + '" data-pie="' + escapar(r.n + ' · ' + r.c) + '">' +
          '<img loading="lazy" src="' + escapar(base + r.p) + '" alt="Foto enviada por ' + escapar(r.n) + '"></button>'
        : '';
      return '<article class="ca-op__item">' +
        '<div class="ca-op__quien">' +
          avatar +
          '<span class="ca-op__nombre">' + escapar(r.n) + '</span>' +
        '</div>' +
        '<div class="ca-op__cabeza">' + estrellas(r.r, 'ca-op__mini') +
          (p.tit ? '<span class="ca-op__tit">' + escapar(p.tit) + '</span>' : '') + '</div>' +
        '<p class="ca-op__meta"><b>Compra verificada</b> · ' + escapar(r.c) + '</p>' +
        '<p class="ca-op__cuerpo">' + escapar(p.corpo) + '</p>' + foto +
      '</article>';
    }

    function pintar() {
      var lote = dados.slice(mostrados, mostrados + PAGINA);
      var html = lote.map(cartao).join('');
      if (mostrados === 0) {
        /* a opinião de quem acabou de escrever vai no topo, marcada */
        var minha = lerPendientes()[sec.dataset.handle];
        lista.innerHTML = (minha ? cartaoPendiente(minha) : '') + html;
      } else lista.insertAdjacentHTML('beforeend', html);
      mostrados += lote.length;
      if (mostrados < dados.length) {
        botao.hidden = false;
        botao.textContent = 'Ver más opiniones (' + (dados.length - mostrados) + ')';
      } else {
        botao.hidden = true;
      }
    }

    fetch(sec.dataset.src, { cache: 'force-cache' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        dados = j;
        pintar();
        var comFoto = dados.filter(function (r) { return r.p; });
        if (tira && comFoto.length) {
          tira.innerHTML = comFoto.map(function (r) {
            return '<button type="button" data-foto="' + escapar(base + r.p) + '" data-pie="' + escapar(r.n + ' · ' + r.c) + '" role="listitem">' +
              '<img loading="lazy" src="' + escapar(base + r.p) + '" alt="Foto enviada por ' + escapar(r.n) + '"></button>';
          }).join('');
          caixaFotos.hidden = false;
        }
      })
      .catch(function () { lista.innerHTML = '<p class="ca-op__cargando">No pudimos cargar las opiniones.</p>'; });

    botao.addEventListener('click', pintar);

    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-foto]');
      if (b) abrirFoto(b.dataset.foto, b.dataset.pie);
    });
    if (visor) {
      visor.addEventListener('click', function (e) {
        if (e.target.closest('[data-ca-op-cerrar]') || e.target === visor) visor.close();
      });
    }
  }

  /* ---------- opinião pendente, guardada no aparelho de quem escreveu ----------

     A pessoa envia, volta para a página do produto e vê a opinião dela lá em
     cima, marcada como pendente. Só ela vê: fica no navegador dela. Para os
     outros, aparece quando a loja publica.

     Não dá para publicar na hora sem um serviço que grave do lado de fora — o
     tema não escreve em lugar nenhum. Isso está dito na página, não escondido. */
  var CHAVE = 'ca_op_pendiente';

  function lerPendientes() {
    try { return JSON.parse(localStorage.getItem(CHAVE) || '{}'); } catch (e) { return {}; }
  }
  function gravarPendientes(o) {
    try { localStorage.setItem(CHAVE, JSON.stringify(o)); } catch (e) { /* cota cheia */ }
  }

  /* A foto vai para o localStorage como data URL. Sem reduzir, uma foto de
     celular estoura a cota de 5 MB e o navegador joga TUDO fora em silêncio. */
  function reduzirFoto(file, lado, aoTerminar) {
    var url = URL.createObjectURL(file), img = new Image();
    img.onload = function () {
      var e = Math.min(lado / img.width, lado / img.height, 1);
      var c = document.createElement('canvas');
      c.width = Math.round(img.width * e); c.height = Math.round(img.height * e);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      try { aoTerminar(c.toDataURL('image/jpeg', 0.72)); } catch (err) { aoTerminar(null); }
    };
    img.onerror = function () { URL.revokeObjectURL(url); aoTerminar(null); };
    img.src = url;
  }

  function cartaoPendiente(r) {
    var p = partir(r.t);
    var foto = r.foto
      ? '<button type="button" class="ca-op__foto" data-foto="' + escapar(r.foto) + '" data-pie="Tu foto">' +
        '<img src="' + escapar(r.foto) + '" alt="Tu foto"></button>' : '';
    return '<article class="ca-op__item ca-op__item--mia">' +
      '<div class="ca-op__quien"><span class="ca-op__av ca-op__av--tu">tú</span>' +
      '<span class="ca-op__nombre">' + escapar(r.n || 'Tu opinión') + '</span>' +
      '<span class="ca-op__tag">Pendiente de publicación</span></div>' +
      '<div class="ca-op__cabeza">' + estrellas(r.r || 5, 'ca-op__mini') +
      (p.tit ? '<span class="ca-op__tit">' + escapar(p.tit) + '</span>' : '') + '</div>' +
      '<p class="ca-op__meta">' + escapar(r.c || '') + '</p>' +
      '<p class="ca-op__cuerpo">' + escapar(p.corpo) + '</p>' + foto +
      '<p class="ca-op__nota-mia">Solo tú ves esto por ahora. Confirmamos tu pedido y la publicamos para todos.</p>' +
    '</article>';
  }

  /* ---------- formulário de opinião ---------- */
  function formulario() {
    var sec = document.querySelector('[data-ca-fop]');
    if (!sec) return;

    var etapa1 = sec.querySelector('[data-ca-fop-etapa1]');
    var etapa2 = sec.querySelector('[data-ca-fop-etapa2]');
    var enviado = /(^|[?&])contact_posted=true/.test(location.search);

    if (enviado && etapa1 && etapa2) { etapa1.hidden = true; etapa2.hidden = false; }

    var sel = sec.querySelector('[data-ca-fop-prod]');
    if (sel) {
      var alvo = new URLSearchParams(location.search).get('product');
      if (alvo) {
        var op = sel.querySelector('option[data-handle="' + CSS.escape(alvo) + '"]');
        if (op) sel.value = op.value;
      }
    }

    var wpp = sec.querySelector('[data-ca-fop-wpp]');
    if (wpp) wpp.addEventListener('input', function () {
      wpp.value = wpp.value.replace(/\D/g, '').slice(0, 10);
    });

    /* etapa 1: guarda a opinião ANTES de enviar — a Shopify recarrega a página
       e os campos se perdem no caminho. */
    var form = sec.querySelector('#ca-form-opinion');
    if (form) form.addEventListener('submit', function () {
      var v = function (s) { var e = sec.querySelector('[data-ca-f="' + s + '"]'); return e ? e.value.trim() : ''; };
      var nota = sec.querySelector('[name="contact[calificacion]"]:checked');
      var opc = sel && sel.selectedOptions[0];
      var handle = opc ? opc.getAttribute('data-handle') : null;
      if (!handle) return;
      var todas = lerPendientes();
      todas[handle] = { n: v('nombre'), c: v('ciudad'), r: nota ? parseFloat(nota.value) : 5,
                        t: v('titulo') + '. ' + v('texto'), foto: null, ts: 1 };
      gravarPendientes(todas);
      try { sessionStorage.setItem('ca_op_ultimo', handle); } catch (e) {}
    });

    /* ETAPA 2 — a foto.

       Se o bloco do app estiver posto na seção, é o input DELE que recebe o
       arquivo, e eu só escuto o mesmo input para montar a prévia: a pessoa
       escolhe a foto uma vez só.

       Se o bloco não estiver posto, o passo ficaria vazio. Então mostro o meu
       próprio seletor e ofereço o WhatsApp da loja para o arquivo chegar. */
    if (etapa2) {
      var caixaApp = sec.querySelector('[data-ca-fop-app]');
      var propria = sec.querySelector('[data-ca-fop-propia]');
      var temApp = caixaApp && caixaApp.querySelector('input, form, iframe, div');
      if (!temApp && propria) propria.hidden = false;

      etapa2.addEventListener('change', function (e) {
        var inp = e.target;
        if (!inp || inp.type !== 'file' || !inp.files || !inp.files[0]) return;
        var handle = null;
        try { handle = sessionStorage.getItem('ca_op_ultimo'); } catch (err) {}
        reduzirFoto(inp.files[0], 600, function (dataUrl) {
          if (dataUrl) {
            var prev = sec.querySelector('[data-ca-fop-previa]');
            if (prev) { prev.querySelector('img').src = dataUrl; prev.hidden = false; }
            if (handle) {
              var todas = lerPendientes();
              if (todas[handle]) { todas[handle].foto = dataUrl; gravarPendientes(todas); }
            }
          }
          var wa = sec.querySelector('[data-ca-fop-wa]');
          var num = (sec.dataset.wa || '').replace(/\D/g, '');
          if (wa && num && !temApp) {
            wa.href = 'https://wa.me/' + num + '?text=' +
              encodeURIComponent('Hola, envío la foto de mi opinión' + (handle ? ' del producto: ' + handle : '') + '.');
            wa.hidden = false;
          }
          var aviso = sec.querySelector('[data-ca-fop-listo]');
          if (aviso && handle) {
            aviso.innerHTML = 'Foto lista. <a href="/products/' + handle + '#opiniones">Ver tu opinión en el producto</a>';
            aviso.hidden = false;
          }
        });
      });
    }
  }

  function arrancar() {
    document.querySelectorAll('[data-ca-op]').forEach(iniciar);
    formulario();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
